import { render, staticRenderFns } from "./BlockType12.vue?vue&type=template&id=c9abb1d2&scoped=true&"
import script from "./BlockType12.vue?vue&type=script&lang=ts&"
export * from "./BlockType12.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType12.vue?vue&type=style&index=0&id=c9abb1d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9abb1d2",
  null
  
)

export default component.exports